import deepmerge from 'deepmerge'
import { Reducer } from 'redux'
import { CartState } from 'types/redux'

import {
  ADD_REDPOINTS_BALANCE_SUCCESS,
  ADD_REDPOINTS_REQUEST,
  ADD_REDPOINTS_SUCCESS,
  ADD_VOUCHER_REQUEST,
  ADD_VOUCHER_SUCCESS,
  RESET_VOUCHER_SUCCESS,
  SET_COLLECTIVE_ORDER,
  UPDATE_CART_SUCCESS
} from './types.consts'
import { CartActionTypes } from './actions'
import preloadedCartState from './preloadedState'

// REDUCER: modify state according to dispatched actions
// eslint-disable-next-line complexity
const reducer: Reducer<CartState> = (
  state: CartState = preloadedCartState,
  action: CartActionTypes
): CartState => {
  switch (action.type) {
    case UPDATE_CART_SUCCESS:
      return {
        ...state,
        data: action.payload
      }
    case SET_COLLECTIVE_ORDER:
      return {
        ...state,
        collectiveOrder: action.payload
      }
    case ADD_VOUCHER_REQUEST:
      return deepmerge(state, {
        voucherLoad: true
      })
    case ADD_VOUCHER_SUCCESS:
      return deepmerge(state, {
        voucherLoad: false,
        voucherAccepted: true
      })
    case RESET_VOUCHER_SUCCESS:
      return deepmerge(state, {
        voucherAccepted: false
      })
    case ADD_REDPOINTS_REQUEST:
      return deepmerge(state, {
        redPointsLoad: true,
        redPointsAccepted: false
      })
    case ADD_REDPOINTS_SUCCESS:
      return deepmerge(state, {
        redPointsLoad: false,
        redPointsAccepted: true
      })
    case ADD_REDPOINTS_BALANCE_SUCCESS:
      return deepmerge(state, {
        ...state,
        redPointsBalance: action.payload
      })
    default:
      return state
  }
}
export default reducer
